var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-dialog",
    {
      ref: "dialog",
      staticClass: "stream-share-dialog",
      attrs: { title: _vm.title, closable: "" },
    },
    [
      _c("ui-input", {
        attrs: {
          autocomplete: "new-password",
          autofocus: "",
          label: "Link password (optional)",
          type: "password",
        },
        model: {
          value: _vm.password,
          callback: function ($$v) {
            _vm.password = $$v
          },
          expression: "password",
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "ui-subheading" }, [_vm._v("Share by")]),
      _vm._v(" "),
      _c(
        "ui-tabs",
        [
          _c(
            "md-tab",
            {
              staticClass: "ui-tab--reset-padding",
              attrs: { "md-label": "Link" },
            },
            [
              _c("share-link", {
                attrs: { password: _vm.password, "stream-id": _vm.streamId },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-tab",
            {
              staticClass: "ui-tab--reset-padding",
              attrs: { "md-label": "E-mail" },
            },
            [
              _c("share-email", {
                attrs: { password: _vm.password, "stream-id": _vm.streamId },
                on: {
                  send: function ($event) {
                    return _vm.$refs.dialog.close()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }